import { InputField } from '@salt/components';
import React from 'react';

const StepProjectName = ({ project, setProject }) => {
  return (
    <div>
      <div className="text-base mb-4">Give your Project a name</div>
      <InputField
        value={project.name}
        labelBackgroundClass="peer-focus:bg-secondary-light peer-[:not(:placeholder-shown)]:bg-secondary-light"
        backgroundClass="bg-secondary-light"
        onChange={(event) => setProject({ ...project, name: event.target.value })}
        placeholder="Project Name"
      />
    </div>
  );
};

export default StepProjectName;
